import { styled, IconButton, Badge } from '@mui/material'
import { BadgeProps } from './IconButton.types'

export const IconButtonStyled = styled(IconButton, {
  name: 'IconButton',
  shouldForwardProp: (prop) =>
    !['action', 'actions', 'clickAtions', 'clickAction'].includes(String(prop))
})(() => ({}))

IconButtonStyled.defaultProps = {
  color: 'inherit',
  size: 'medium'
}

export const IconButtonBadgeWrapper = styled(Badge, {
  shouldForwardProp: (prop) => !['floated'].includes(String(prop))
})<Partial<BadgeProps>>(({ floated = false, badgeContent }) => ({
  '& .MuiBadge-badge':
    floated || !badgeContent
      ? {
          fontSize: '11px',
          fontWeight: 'bold'
        }
      : {
          position: 'relative',
          transform: 'none',
          top: 2,
          fontSize: '11px',
          fontWeight: 'bold'
        }
}))
